<template>
  <section class="sme-container__info">
    <template>
      <div
        class="box">
        <div
          class="table"
        >
          <div class="th font-14" >Premium</div>
          <div
            v-for="(item,sumIndex) in preimum"
            :key="sumIndex"
            class="tr"
          >
            <span class="fw-600">{{ item.item }}</span>
            <span>
              {{ item.premium|formatMoney(2, true) }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="box">
        <div
          class="table"
        >
          <div class="th font-14" >Excess</div>
          <div
            v-for="(item,sumIndex) in excess"
            :key="'excess_'+sumIndex"
            class="tr"
          >
            <span class="fw-600">{{ item.item }}</span>
            <span>
              {{ item.content }}
            </span>
          </div>
          <div
            v-if="excess.length<=0"
            class="tr pd-b-20 pd-t-16">-</div>
        </div>
      </div>
    </template>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'smePremiumCoverage',
  components:{
  },
  mixins: [MixinOptions,MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
  },
  data(){
    return{
    }
  },
  computed: {
    preimum(){
      let {sidebar_info}=this.formData||{}
      return sidebar_info
    },
    excess(){
      let {excess}=this.formData||{}
      return excess||[]
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
/deep/.upload-container{
  width: 320px!important;
  .upload-card {
    width: 320px;
    height: 150px;
  }
}
.flex-start{
  align-items: flex-start !important;
}
.marketing + .marketing{
  margin-top: 10px;
}
</style>
